import type { GridColDef, GridRowModel } from '@mui/x-data-grid-premium';
import { isEmpty } from 'lodash';

export const generateTempId = () => Math.round(Math.random() * Number.MAX_SAFE_INTEGER);

export const makeCol = (field: string, headerName: string, overrides: Partial<GridColDef> = {}): GridColDef => ({
    field,
    headerName,
    flex: 1,
    minWidth: 100,
    type: 'string',
    sortable: false,
    valueGetter: (value, row: GridRowModel) => (isEmpty(row) ? undefined : value),
    ...overrides
});